export const HeaderStrings = {
  Open_side_menu: 'Open side menu',
};

export const UtilityStings = {
  Wishlist: 'Wishlist',
  My_Cart: 'My Cart',
  Contact: 'Contact',
};
export const AccountStings = {
  Greeting: 'Hi, ',
  User: 'User',
  Account: 'Account',
  Login: 'Login',
};

export const ReviewsMessage = {
  updated: 'Rating updated successfully',
  submitted: 'Rating submitted successfully',
};
export const ReviewsSource = {
  magazine: 'magazin',
  recipe: 'rezepte',
};

export enum HttpStatus {
  CONTINUE = 100,
  SWITCHING_PROTOCOLS = 101,
  PROCESSING = 102,
  EARLYHINTS = 103,
  STATUS_CODE_200 = 200,
  STATUS_CODE_201 = 201,
  ACCEPTED = 202,
  NON_AUTHORITATIVE_INFORMATION = 203,
  NO_CONTENT = 204,
  RESET_CONTENT = 205,
  PARTIAL_CONTENT = 206,
  AMBIGUOUS = 300,
  MOVED_PERMANENTLY = 301,
  FOUND = 302,
  SEE_OTHER = 303,
  NOT_MODIFIED = 304,
  TEMPORARY_REDIRECT = 307,
  PERMANENT_REDIRECT = 308,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  PROXY_AUTHENTICATION_REQUIRED = 407,
  REQUEST_TIMEOUT = 408,
  CONFLICT = 409,
  GONE = 410,
  LENGTH_REQUIRED = 411,
  PRECONDITION_FAILED = 412,
  PAYLOAD_TOO_LARGE = 413,
  URI_TOO_LONG = 414,
  UNSUPPORTED_MEDIA_TYPE = 415,
  REQUESTED_RANGE_NOT_SATISFIABLE = 416,
  EXPECTATION_FAILED = 417,
  I_AM_A_TEAPOT = 418,
  MISDIRECTED = 421,
  UNPROCESSABLE_ENTITY = 422,
  FAILED_DEPENDENCY = 424,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
  HTTP_VERSION_NOT_SUPPORTED = 505,
}

export const TranslationDefaultValues = {
  videoLoadingError: 'Ihr Browser unterstützt das Video-Tag nicht.',
  reviews: 'Bewertungen',
  relatedRecipe: 'Verwandtes Rezept',
  showAllResults: 'Alle Ergebnisse anzeigen',
  hit: 'Treffer',
  relatedMagazine: 'Verwandtes Magazin',
  relatedProduct: 'Verwandte Produkte',
  relatedFaq: 'Verwandte FAQ',
  relatedTvOffer: 'Verwandte TV-Angebot',
  spareProduct: 'Ersatzprodukt',
  noResultsFound: 'Kein passendes Suchergebnis gefunden',
};

export const UnzerPaymentValidationProperties = {
  cardHolderNameValidation: {
    required: true, // Ensures the cardholder name is required
    minLength: 1, // Minimum length for the name (typically at least one character)
    maxLength: 50, // Maximum length for the name (adjust as needed)
    pattern: /^[A-Za-z\s]+$/, // Only allows alphabetic characters and spaces
  },
  cardNumberValidation: {
    required: true, // Ensures the card number is required
    luhn: true, // Validates the Luhn algorithm (standard for credit card validation)
    length: {
      min: 13, // Minimum length for card number (commonly 13 for Visa)
      max: 16, // Maximum length (commonly 16 for other card types like MasterCard, etc.)
    },
  },
};

export const DefaultCategoryName = {
  kuche: 'kuche' || 'magazin-kueche',
  recipe: 'rezepte',
  magazine: 'magazin',
  schlafen: 'schlafen' || 'magazin-schlafen',
  reinigen: 'reinigen',
  rund_ums_haus: 'rund-ums-haus',
  reinigung: 'reinigung',
  fitness: 'fitness',
  beauty: 'beauty-und-wohlbefinden',
  kochen: 'kuechen',
  magazinkuche: 'magazin-kueche',
  magazinschalfen: 'magazin-schlafen',
  lifestyle: 'lifestyle',
  product: '/p',
  home: '',
  kueche: 'kueche',
  kuechen: 'küche',
  accesories: 'Zubehör',
  spareParts: 'Ersatzteile',
  topAngeboteService: 'Top Angebote & Service',
};

export const REVIEW_MAX_LIMIT = 5;
export const INSTALMENT_MIN_PAYMENT_LIMIT = 15000;
export const INVOICE_MIN_PAYMENT_LIMIT = 1000;
export const UNDEFINED = undefined;

export const PRODUCT_TYPE = 'PayAndShip';
export const PLACEMENT = 'Cart';
export const BUTTON_COLOR = 'Gold';

export const CONTINUE_READING = 'weiterlesen';
export const privacyPolicy = 'datenschutz';
export const termsCondition = 'agb';
export const cancellationPolicy = 'widerrufsrecht';
export const Billing_Address = 'billing';
export const Shipping_Address = 'shipping';
export const READ_MORE = 'mehr lesen';
export const COOK_AGAIN = 'Jetzt nachkochen';
export const SEE_AND_READ_MORE = 'Weiter zum Genius Magazine – ich möchte mehr davon sehen und lesen';
export const MORE_INFO = 'Mehr Informationen';
export const BUY_NOW_AND_SAVE = 'Jetzt kaufen und sparen';
export const CONTENT_EXPAND_NUMBER = 1;
export const CONTENT_LOADING_PRODUCTS = 'Weiter Produkte laden';
export const NO_ARTICLE_MESSAGE = 'Keine Artikel verfügbar';
export const CART_SLUG = '/cart/';
export const HOME_SLUG = '/';
export const CHECKOUT_URL = '/checkout';
export const CHECKOUT_SLUG = '/checkout/?step=1';
export const CHECKOUT_STEP2_SLUG = '/checkout/?step=2';
export const CHECKOUT_STEP3_SLUG = '/checkout/?step=3';
export const Accesories_Slug = 'zubehoer';
export const Spareparts_Slug = 'ersatzteile';
export const CategoryPage = 'category';
export const BONUS = 'bonus';
export const UPSELL = 'upsell';
export const GRATIS = 'GRATIS';
export const KOMBI = 'KOMBI';
export const LOADING_AMAZON_PAY = 'Loading Amazon Pay';
export const ALLOWBACKORDER = 'allowBackorder';
export const Title = 'title';
export const Description = 'description';
export const CARD = 'card';
export const PRODUCT = 'product';
export const SWIZ_COUNTRY_CODE = 'de-CH';
export const passwordLevels = ['Empty', 'Weak', 'Medium', 'Strong', 'Very Strong', 'Super Strong'];
export const percentageImage = '/images/Prozent_36px_A.png';
export const HIDE_SOLD_OUT_PRODUCTS = 'hideSoldOutProducts';
export const Campaign_Genius_Web = 'campaign-genius-web';
export const Trusted_Shop_Link = 'https://www.trustedshops.de/bewertung/info_X787697D7D36BF1C9B20A04ED8898325D.html';
export const SPECIAL_CHARACTER_REGEX = /[!@#$%^&*(),?":{}|<>]/;

export const LocalStorageKeys = {
  selectedSort: 'selectedSort',
  selectedBrands: 'selectedBrands',
  isCampaignFilterEnabled: 'isCampaignFilterEnabled',
  default: 'default',
};

export const Icons = {
  camera: 'cameraIcon',
  video: 'videoIcon',
  fullScreen: 'FullscreenIcon',
};

export const EVENT_MAP = ['mousedown', 'mouseup', 'click'];

export const searchType = {
  Global: 'global',
  Tvoffer: 'tvOffer',
  FAQ: 'faq',
  Magazine: 'magazine',
  Recipe: 'recipe',
  Product: 'product',
  SearchCategory: 'searchCategory',
  SpareParts: 'spareProducts',
};

export const SourceData = {
  sourceData: 'setByContent',
};

export const LOCALE_COUNTRY_CODE = ['de-AT', 'de-CH'];
export const GERMAN_COUNTRY_CODE = 'de-DE';
export const AUSTRIA_COUNTRY_CODE = 'de-AT';
export const PRESENT_URL = 'https://www.genius.tv';
export const RABATT = 'discount';
export const RABATT_LABEL = 'Rabatt';
export const POSTAL_CODE_LENGTH: any = {
  'de-DE': 5,
  'de-CH': 4,
  'de-AT': 4,
};
export const ADDRESS_MIN_LENGTH = 3;
export const POSTALCODE_MAX_LENGTH = 5;
export const YOU_CAN_CHANGE_OR_REVOKE_YOUR_COOKIE_SETTINGS_HERE =
  'Sie können Ihre Cookie-Einstellungen hier ändern oder widerrufen';
export const YOU_CAN_CHANGE_YOUR_COOKIE_SETTINGS = 'Sie können Ihre Cookie-Einstellungen';
export const HERE = 'hier';
export const CHANGE_OR_REVOKE = 'ändern oder widerrufen';

export const FooterImages = {
  MasterCard: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_VemUxgztGV4ggToCRRDxGE334P-7wQ_Tqw&s',
  AmazonPay: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJqbCvUxDsIeOYa51HsMGhIcF_5Dj8EEatlg&s',
  PayPal: 'https://download.logo.wine/logo/PayPal/PayPal-Logo.wine.png',
  Visa: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2rA-0ZxPm7g-iQzApiZvLriUmnQtmRhEwmw&s',
  Gpay: 'https://purepng.com/public/uploads/large/purepng.com-google-pay-gpay-logobrandlogobrand-logoiconssymbolslogosgoogle-681522937443muxmx.png',
  Eps: 'https://searchvectorlogo.com/wp-content/uploads/2020/03/eps-ueberweisung-logo-vector.png',
  ApplePay: 'https://download.logo.wine/logo/Apple_Pay/Apple_Pay-Logo.wine.png',
  Twint:
    'https://www.magnolia-cms.com/.imaging/mte/corpweb2021/1440/dam/customers/customer-logos/P-T/logo-twint-2023-02.png/jcr:content/twint-logo-2024.png',
  PostFinance: 'https://logowik.com/content/uploads/images/postfinance9610.logowik.com.webp',
};

export const ResolutionTags = {
  categoryDesktop: '300x200',
  categoryMobile: '150x100',
  articleTablet: '400x300',
  articleDesktop: '400x300',
  articleMobile: '390x260',
  productCategoryDesktop: '300x300',
  productCategoryMobile: '200x300',
  specialOfferDesktop: '1000x350',
  specialOfferMobile: '400x300',
  campaignTeaserBannerDesktop: '1280x400',
  campaignTeaserBannerMobile: '450x150',
  campaignTeaser1BannerMobile: '400x400',
  campaignTeaser2ImageDesktop: '400x400',
  campaignTeaser2ImageMobile: '400x400',
  offerOfTheMonthDesktop: '400x300',
  offerOfTheMonthMobile: '400x300',
  brandImageDesktop: '400x400',
  brandImageMobile: '350x350',
  productTeaserDesktop: '400x300',
  productTeaserMobile: '160x160',
  mainTag: 'main',
  pdpProductImageDesktop: '1200x800',
  pdpProductImageMobile: '1200x800',
  bannerImageDesktop: '1280x280',
  bannerImageMobile: '450x50',
  spareandrepairDesktop: '600x200',
  spareandrepairTablet: '600x200',
  spareandrepairMobile: '200x200',
  campaignTeaser1BannerDesktop: '1280x350',
  topCampaignOfferDesktop: '300x400',
  topCampaignOfferMobile: '200x400',
  topProductOfferDesktop: '300x195',
};

export const SystemTags = {
  campaignProductImage: 'campaign_product_image',
  productName: 'product_name',
  productShortDescription: 'product_short_description',
  productRating: 'product_rating',
  productPrice: 'product_price',
  productCampaignPrice: 'product_campaign_price',
  headline: 'headline_h2',
  campaignImage: 'campaign_image',
  productPreviewImage: 'product_preview_image',
  campaignLabel: 'campaign_label',
  campaignBannerFullwidth: 'campaign_banner_fullwidth',
  magazineArticleImage: 'magazine_article_image',
  recipeImage: 'recipe_image',
  magazineShortDescription: 'magazine_article_short_description',
  recipeShortDescription: 'recipe_short_description',
  magazineRating: 'magazine_rating',
  recipeRating: 'recipe_rating',
  magazineCategoryColor: 'magazine_category_color',
  magazineCategoryImageNav: 'magazine_category_image_nav',
  magazineCategoryName: 'magazine_category_name',
  magazineCategoryMainImage: 'magazine_category_image_fullwidth',
  introText: 'intro_text',
  descriptionText: 'description_text',
  campaignRecipeImage: 'campaign_recipe_image',
  magazineTitle: 'magazine_title',
  faqImage: 'FAQ_category_image',
  description: 'description',
};

export const ProductAttributeNames = {
  brand: 'brand',
  shortDescription: 'shortDescription',
  productDescription: 'productDescription',
  productMainAttribute: 'product_main_attribute',
  content: 'content',
  technicalData: 'technicalData',
  pdpPageType: 'pdp',
  image: 'image',
  video: 'video',
  srcType: 'string',
  braCalculator: 'braCalculator',
};

export const Filtervalues = {
  createdAt: 'createdAt',
  AZ: 'A-Z',
  Newest: 'Neueste',
  Sort: 'Sortieren',
};

export const cartIconImageUrl =
  'https://res.cloudinary.com/dlwdq84ig/image/upload/v1709120760/gd4rqlatw0nqoy0xhhup.png';

export const NewsletterEmailvalues = {
  NOEmail: 'Bitte füllen Sie alle rot markierten Felder aus.',
  InvalidMail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  ValidMail: 'Vielen Dank. Wir haben Ihre Adresse eingetragen.',
  InvalidColor: 'red',
  ValidColor: 'green',
};

export const contactIconUrl = 'https://res.cloudinary.com/dlwdq84ig/image/upload/v1708936477/uo2yzcluw970wgh6yfrs.png';

export const STORE_COUNTRIES_LIST: Record<string, string> = {
  DE: 'genius-web-de',
  AT: 'genius-web-at',
  CH: 'genius-web-ch',
};

export const STORE_KEY_LIST: Record<string, string> = {
  'de-DE': 'genius-web-de',
  'de-AT': 'genius-web-at',
  'de-CH': 'genius-web-ch',
};

export const STORE_COUNTRIES_MAP: Record<string, string> = {
  DE: 'Germany',
  AT: 'Austria',
  CH: 'Switzerland',
};
export const STORE_LOCALE_MAP: Record<string, string> = {
  'de-DE': 'Deutsch (Deutschland)',
  'de-AT': 'Deutsch (Österreich)',
  'de-CH': 'Deutsch (Schweiz)',
};

export const servicesNames = {
  servicename: 'service-uebersicht',
  offer: '/top-angebote-service',
};

export const excludedModules = new Set([
  'product_name_main_attribute',
  'sales_configurator',
  'trusted_shops_rating_part1',
  'single_product_images',
  'bra_calculator',
  'sales_support',
  'order_action_items',
  'single_product_price_shipping_info',
]);

export const warningLength = {
  warningNumber: 100,
};

export const EXCLUDED_PRODUCT_MODULES = ['bonus_products', 'tv_upsell_products'];
export const downloadVariables = {
  download: 'Download',
};

export const BENNER_IMAGE_MODULES = ['banner_image', 'magazine_banner_image'];

export const ModuleName = {
  MagazineArticleListing: 'magazine_article_listing',
  MagazineSingleArticle: 'magazine_single_article',
  TvUpsellProducts: 'tv_upsell_products',
  BonusProducts: 'bonus_products',
  categoryHeadline: 'category_headline',
};

export const MAGAZINEINTROPDP = {
  MagazineIntroPDP: 'magazine_intro_pdp',
};
export const serviceStatus = {
  ReviewUpdatedSuccessfully: 'Bewertung erfolgreich aktualisiert!',
};

// Credit card error types
export const CREDIT_CARD_ERROR_TYPE = {
  HOLDER: 'holder',
  EXPIRY: 'expiry',
  CVC: 'cvc',
  NUMBER: 'number',
  DEFAULT: 'default',
};

export const SERVICEPAGE_URL = '/top-angebote-service/service-uebersicht/';
export const DUMMY_IMAGE = 'https://dummyimage.com/164x104/fff&text=Kein Bild';

export const SHIPPING_DELIVERY_OPTION = {
  DHL: 'dhl',
  FREIGHT: 'freight',
  GRITHM: 'girthm-measurement-300cm',
  BULKY: 'bulky',
};

export const PAYMENT_STATUS = {
  CREATED: 'CREATED',
  APPROVED: 'APPROVED',
  CANCELED: 'CANCELED',
  PAYER_ACTION_REQUIRED: 'PAYER_ACTION_REQUIRED',
};

export const ArticleValues = {
  Inhaltsverzeichnis: 'Inhaltsverzeichnis',
  Author: 'Autor',
};

export const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  const { name, value } = target;

  // Default cleaned value without special characters (allows German characters)
  // let cleanedValue = value.replace(/[^a-zA-Z0-9\säöüÄÖÜß]/g, '');

  if (name === 'line1' || name === 'line2') {
    if (target.value.length) {
      e.preventDefault();
    } else {
      target.value = target.value;
    }
  }

  if (name === 'email') {
    // Allow letters, numbers, @, dots, and hyphens in email
    const cleanedValue = value.replace(/[^a-zA-Z0-9@._-]/g, '');
    if (e.key === ' ') {
      e.preventDefault(); // Prevent spaces in email
    }
  }
};

export const AccountIcon = '/images/profile_icon.png';

export const AMAZON_PAY_EU_SCRIPT = 'https://static-eu.payments-amazon.com/checkout.js';

export const RECIPESLUG = 'https://rezepte.genius.tv/';
export const GENIUSSLUG = 'https://www.genius.tv/';

export const Breadcrumbschecks = {
  tv: '/',
  shop: '/shop/',
  topAngebote: '/top-angebote-service/',
};

export const ENABLE_GERMAN_STORE = process.env.ENABLE_GERMAN_STORE === 'true';
